import { InspectionStandardTypes } from '../../enums/InspectionStandardTypes';

export const compressedFilesToDecompositionInspectionStandardTypes = [InspectionStandardTypes.Free, InspectionStandardTypes.Nen2767];
